import {common_utils} from "../common/common_utils";

function game_2001()
{

}


game_2001.getWinInfo = function(this1,obj)
{
  if(common_utils.isNull(obj))
  {
    return winInfo;
  }
  let winInfo = "";
  let winInfoTip= "";
  let index = 0;
  let winValue = 0;
   Object.keys(obj).map(function(key) {
     let subitem = obj[key];
     let bet = 0;
     let win = 0;
     let InsuranceAmount = 0;
     let InsuranceWin = 0;
     let SplitHandPokerBet = 0;
     let SplitHandPokerWin= 0;
     if(subitem.HandPokerBet)
     {
       bet = subitem.HandPokerBet;
     }
     if(subitem.HandPokerWin)
     {
       win = subitem.HandPokerWin;
     }
     if(subitem.InsuranceAmount)
     {
       InsuranceAmount = subitem.InsuranceAmount;
     }
     if(subitem.InsuranceWin)
     {
       InsuranceWin = subitem.InsuranceWin;
     }
     if(subitem.SplitHandPokerBet)
     {
       SplitHandPokerBet = subitem.SplitHandPokerBet;
     }
     if(subitem.SplitHandPokerWin)
     {
       SplitHandPokerWin = subitem.SplitHandPokerWin;
     }
     if(index > 0)
     {
       winInfoTip+= " + ";
     }
     let str_player_poker = this1.$t("lang.str_player_poker")+(index+1)
     if(InsuranceAmount>0 || SplitHandPokerBet>0)
     {

       let InsuranceValue = InsuranceWin - InsuranceAmount;
       let SplitHandPokeValue = SplitHandPokerWin-SplitHandPokerBet;
       if(index > 0)
       {
         winInfo += " + ";
       }
       winInfo += "(" + common_utils.getValueFixed(win)+"-"+common_utils.getValueFixed(bet)
       winInfoTip += str_player_poker+"("+this1.$t("lang.str_game_win_value")+"-"+this1.$t("lang.str_betd")+" + "
       if(InsuranceAmount)
       {
         winInfoTip += this1.$t("lang.str_bj_bx")+"("+this1.$t("lang.str_game_win_value")+"-"+this1.$t("lang.str_betd")+")"
         if(InsuranceValue>0)
         {
           winInfo += "+";
         }
         winInfo += common_utils.getValueFixed(InsuranceWin)+"-"+common_utils.getValueFixed(InsuranceAmount)
       }
       if(SplitHandPokerBet>0)
       {
         winInfoTip += this1.$t("lang.str_game_split")+"("+this1.$t("lang.str_game_win_value")+"-"+this1.$t("lang.str_betd")+")"
         winInfo += "+";
         winInfo += common_utils.getValueFixed(SplitHandPokerWin)+"-"+common_utils.getValueFixed(SplitHandPokerBet)
       }
       winInfoTip+= ")"
       winInfo += ")"
     }
     else
     {

       if(index > 0)
       {
         winInfo += "+";
       }
       winInfo += "(" + common_utils.getValueFixed(win)+"-"+common_utils.getValueFixed(bet)+ ")";
       winInfoTip += str_player_poker+"("+this1.$t("lang.str_game_win_value")+"-"+this1.$t("lang.str_betd")+ ")";
     }
     winValue += win - bet + InsuranceWin - InsuranceAmount + SplitHandPokerWin - SplitHandPokerBet;
     index++;
  });
   if(obj.length > 1)
   {
       winInfo += " = ";
       winInfoTip +=" = ";
       let index = 0;
       Object.keys(obj).map(function(key) {
         let subitem = obj[key];
         let bet = 0;
         let win = 0;
         let InsuranceAmount = 0;
         let InsuranceWin = 0;
         let SplitHandPokerBet = 0;
         let SplitHandPokerWin= 0;
         let str_player_poker = this1.$t("lang.str_player_poker")+(index+1)
         if(subitem.HandPokerBet)
         {
           bet = subitem.HandPokerBet;
         }
         if(subitem.HandPokerWin)
         {
           win = subitem.HandPokerWin;
         }
         if(subitem.InsuranceAmount)
         {
           InsuranceAmount = subitem.InsuranceAmount;
         }
         if(subitem.InsuranceWin)
         {
           InsuranceWin = subitem.InsuranceWin;
         }
         if(subitem.SplitHandPokerBet)
         {
           SplitHandPokerBet = subitem.SplitHandPokerBet;
         }
         if(subitem.SplitHandPokerWin)
         {
           SplitHandPokerWin = subitem.SplitHandPokerWin;
         }
         let winValue = win - bet;
         if(index>0)
         {
           winInfo += " + ";
           winInfoTip += " + ";
         }
         winInfoTip += str_player_poker;
         winInfo += "("+common_utils.getValueFixed(winValue)
         winInfoTip += "("+this1.$t("lang.str_winorfail")
         if(InsuranceAmount>0)
         {
           let InsuranceValue = InsuranceWin-InsuranceAmount;
           if(InsuranceValue>0)
           {
             winInfo += "+";
           }
           winInfoTip += "+"+this1.$t("lang.str_bj_bx")+this1.$t("lang.str_winorfail");
           winInfo += common_utils.getValueFixed(InsuranceValue)
         }
         if(SplitHandPokerBet>0)
         {
           let SplitHandPokeValue = SplitHandPokerWin-SplitHandPokerBet;
           if(SplitHandPokeValue>0)
           {
             winInfo += "+";
           }
           winInfoTip += "+"+this1.$t("lang.str_game_split")+this1.$t("lang.str_winorfail");
           winInfo += common_utils.getValueFixed(SplitHandPokeValue)
         }
         winInfo+= ")"
         winInfoTip += ")"
         index++;
     });
   }
    winInfoTip += " = "+ this1.$t("lang.tr_game_total_win")
    winInfo += " = " +((winValue) / 100).toFixed(2);
    return [winInfo,winInfoTip];
}

export {
  game_2001
};



// WEBPACK FOOTER //
// ./src/components/joker/game_2001.js